import { getAll, update, remove } from '../services/datastore';

export const FETCH_ALL = 'activitiesManagement/fetch_all';
export const FETCH_ALL_SUCCESS = 'activitiesManagement/fetch_all_success';
export const FETCH_ALL_FAILURE = 'activitiesManagement/fetch_all_failure';

export const SAVING = 'activitiesManagement/saving';
export const SAVING_SUCCESS = 'activitiesManagement/saving_success';
export const SAVING_FAILURE = 'activitiesManagement/saving_failure';

export const DELETING = 'activitiesManagement/deleting';
export const DELETING_SUCCESS = 'activitiesManagement/deleting_success';
export const DELETING_FAILURE = 'activitiesManagement/deleting_failure';

export const UPDATE = 'activitiesManagement/update';

export const CATEGORIES = {
  sportEvent: 'Manifestation sportive',
  shooting: 'Tournages ou prises de vues',
  noSportingOtherEvent: 'Autres sorties non sportives',
  other: 'Autres',
  schoolOuting: 'Sorties scolaires',
};

const DATASTORE_PREFIX = 'onf.fms.';

export const initialState = {
  list: [],
  loading: false,
  updating: false,
  deleting: false,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ALL:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_ALL_SUCCESS: {
      return {
        ...state,
        list: action.activities,
      };
    }
    case FETCH_ALL_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    case SAVING:
      return {
        ...state,
        error: null,
        updating: true,
      };
    case SAVING_SUCCESS: {
      const list = [...state.list];
      const { data } = action;
      const pos = list.findIndex(({ key }) => key === data.key);
      if (pos === -1) {
        list.push(data);
      } else {
        list.splice(pos, 1, data);
      }

      return {
        ...state,
        list,
        updating: false,
      };
    }
    case SAVING_FAILURE:
      return {
        ...state,
        updating: false,
        error: action.error,
      };

    case DELETING:
      return {
        ...state,
        list: state.list.filter(({ key }) => key !== action.key),
        deleting: false,
        error: null,
      };
    case DELETING_SUCCESS:
      return {
        ...state,
        deleting: false,
      };
    case DELETING_FAILURE:
      return {
        ...state,
        deleting: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export const getShortKey = key => key.replace(DATASTORE_PREFIX, '');

export const getActivity = (list, key) =>
  (list.find(({ key: aKey }) => aKey === `${DATASTORE_PREFIX}${key}`) || null);

export const getActivityValue = (list, key) =>
  (list.find(({ key: aKey }) => aKey === `${DATASTORE_PREFIX}${key}`) || {}).value;

export const fetchActivitiesAction = () => async dispatch => {
  dispatch({
    type: FETCH_ALL,
  });

  try {
    const stores = await getAll();
    const activities = [
      ...stores.filter(({ key }) => key.match(DATASTORE_PREFIX)).reduce((acc, activity) =>
        [...acc, {
          ...activity,
          value: {
            ...activity.value,
            categoryLabel: CATEGORIES[activity.value.category],
          },
        }], []),
    ];
    dispatch({
      type: FETCH_ALL_SUCCESS,
      activities,
    });
  } catch (error) {
    dispatch({
      type: FETCH_ALL_FAILURE,
      error,
    });
  }
};

export const saveActivityAction = (key, activity) => async dispatch => {
  dispatch({
    type: SAVING,
  });

  try {
    const fullKey = `${DATASTORE_PREFIX}${getShortKey(key)}`;
    await update(fullKey, activity);
    dispatch({
      type: SAVING_SUCCESS,
      data: {
        key: fullKey,
        value: activity,
      },
    });
  } catch (error) {
    dispatch({
      type: SAVING_FAILURE,
      error,
    });
  }
};

export const deleteActivityAction = key => async dispatch => {
  const fullKey = `${DATASTORE_PREFIX}${getShortKey(key)}`;

  dispatch({
    type: DELETING,
    key: fullKey,
  });

  try {
    await remove(fullKey);
    dispatch({
      type: DELETING_SUCCESS,
    });
  } catch (error) {
    dispatch({
      type: DELETING_FAILURE,
      error,
    });
  }
};



// WEBPACK FOOTER //
// ./src/modules/activities-management.js